import { getProductInfo, pageTitle } from '@/shbdeployer/product';

angular.module('shbdeployer.app').controller('SidebarController', SidebarController);

/**
 * Контроллер боковой панели: права текущего пользователя, текущее окружение, сведения о продукте.
 */
/* @ngInject */
function SidebarController($scope, $transitions, StateManager, Notifications, Authentication, UserService, EndpointProvider) {
  $scope.applicationState = StateManager.getState();
  $scope.endpointState = EndpointProvider.endpoint();
  $scope.product = getProductInfo();

  function checkPermissions(memberships) {
    $scope.isTeamLeader = memberships.some((membership) => membership.Role === 1);
  }

  function isClusterAdmin() {
    return Authentication.isAdmin();
  }

  function shouldShowStacks() {
    if (isClusterAdmin()) {
      return true;
    }

    const endpoint = EndpointProvider.currentEndpoint();
    if (!endpoint || !endpoint.SecuritySettings) {
      return false;
    }

    return endpoint.SecuritySettings.allowStackManagementForRegularUsers;
  }

  async function initView() {
    $scope.uiVersion = StateManager.getState().application.version;
    $scope.logo = StateManager.getState().application.logo;
    $scope.product = getProductInfo();

    $scope.endpointId = EndpointProvider.endpointID();
    $scope.showStacks = shouldShowStacks();

    const userDetails = Authentication.getUserDetails();
    const isAdmin = isClusterAdmin();
    $scope.isAdmin = isAdmin;

    if (!isAdmin) {
      try {
        const memberships = await UserService.userMemberships(userDetails.ID);
        checkPermissions(memberships);
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось получить сведения о членстве в командах');
      }
    }
  }

  initView();

  $transitions.onEnter({}, async () => {
    $scope.endpointId = EndpointProvider.endpointID();
    $scope.showStacks = shouldShowStacks();
    $scope.isAdmin = isClusterAdmin();
    document.title = pageTitle($scope.applicationState.endpoint.name);
  });
}
